import { getFormattedValidationErrorFromAction } from 'Utils/getFormattedValidationErrorFromAction';

const initialState = {
  isLoading: true,
  cart: [],
  requestMake: false,
  finishRequests: false,
  cartFinishRequests: false,
  coupon: null,
  errorMessageCoupon: null,
  isSuccessCoupon: false,
  isLoadingCoupon: false,
  errorSkus: [],
  errorSkusCart: [],
};
export const FETCH_CART = 'FETCH_CART';
export const FETCH_CART_SUCCESS = `${FETCH_CART}_SUCCESS`;
export const FETCH_CART_FAIL = `${FETCH_CART}_FAIL`;

export const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART';
export const ADD_ITEM_TO_CART_SUCCESS = `${ADD_ITEM_TO_CART}_SUCCESS`;
export const ADD_ITEM_TO_CART_FAIL = `${ADD_ITEM_TO_CART}_FAIL`;

export const UPDATE_ITEM_CART = 'UPDATE_ITEM_CART';
export const UPDATE_ITEM_CART_SUCCESS = `${UPDATE_ITEM_CART}_SUCCESS`;
export const UPDATE_ITEM_CART_FAIL = `${UPDATE_ITEM_CART}_FAIL`;

export const DELETE_ITEM_CART = 'UPDATE_ITEM_CART';
export const DELETE_ITEM_CART_SUCCESS = `${DELETE_ITEM_CART}_SUCCESS`;
export const DELETE_ITEM_CART_FAIL = `${DELETE_ITEM_CART}_FAIL`;

export const ADD_COUPON_TO_CART = 'ADD_COUPON_TO_CART';
export const ADD_COUPON_TO_CART_SUCCESS = `${ADD_COUPON_TO_CART}_SUCCESS`;
export const ADD_COUPON_TO_CART_FAIL = `${ADD_COUPON_TO_CART}_FAIL`;

export const REMOVE_COUPON_TO_CART = 'REMOVE_COUPON_TO_CART';
export const REMOVE_COUPON_TO_CART_SUCCESS = `${REMOVE_COUPON_TO_CART}_SUCCESS`;
export const REMOVE_COUPON_TO_CART_FAIL = `${REMOVE_COUPON_TO_CART}_FAIL`;

export const RESET_ERROR_MESSAGE_COUPON = 'RESET_ERROR_MESSAGE_COUPON';

const typeVirtualVoucher = 'EXTERNALVOUCHERVIRTUAL';
const equalsVirtualVoucher = (item) => item.vendor.type === typeVirtualVoucher;
const diffVirtualVoucher = (item) => item.vendor.type !== typeVirtualVoucher;

const calculatorCount = (current, item) => {
  return current + item.quantity;
};

export const resetErrorMessageCoupon = () => {
  return {
    type: REMOVE_COUPON_TO_CART,
    payload: {
      errorMessageCoupon: null,
    },
  };
};

const CartReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_CART:
      return { ...state, isLoading: true, cartFinishRequests: false };
      case FETCH_CART_SUCCESS:
      const { data } = action.payload;
      const count = data.items.reduce(calculatorCount, 0);
      
      const hasItemsVirtualVoucher = data.items.some(equalsVirtualVoucher);
      const hasItemsDifferentVirtualVoucher =
      data.items.some(diffVirtualVoucher);
      return {
        ...state,
        isLoading: false,
        cart: action.payload.data,
        coupon: action.payload.data.coupon,
        errorSkusCart: action.payload.data.coupon?.errorSkus ?? [],
        count,
        isLoadingCoupon: false,
        hasItemsVirtualVoucher,
        hasItemsDifferentVirtualVoucher,
        itemAdded: false,
        isError: false,
        cartFinishRequests: true,
        error: null,
        changeQuantity: action.payload.data.items.map(item => item.quantity)
      };
      case FETCH_CART_FAIL:
        const errorDataCart = getFormattedValidationErrorFromAction(action) ?? null;
        return {
          ...state,
          isLoading: false,
        error: errorDataCart,
        cartFinishRequests: true,
      };
    case ADD_ITEM_TO_CART:
      return {
        ...state,
        isLoading: true,
        finishRequests: false,
        cartFinishRequests: false,
      };
    case ADD_ITEM_TO_CART_SUCCESS:
      return {
        ...state,
        isLoading: false,
        itemAdded: true,
        redirectToCart: action.payload.redirectToCart,
        finishRequests: true,
        cartFinishRequests: false,
      };
    case ADD_ITEM_TO_CART_FAIL:
      const errorDataAddItem = getFormattedValidationErrorFromAction(action);
      return {
        ...state,
        isLoading: false,
        isLoadingRedirect: false,
        error: errorDataAddItem,
        isError: true,
        finishRequests: true,
        cartFinishRequests: false,
      };
    case UPDATE_ITEM_CART:
      return {
        ...state,
        isLoading: true,
        wasModified: true,
        isUpdating: true,
        finishRequests: false,
        cartFinishRequests: false,
        hasError: false,
      };
    case UPDATE_ITEM_CART_SUCCESS:
      return {
        ...state,
        finishRequests: true,
        cartFinishRequests: false,
        isLoading: false,
        isUpdating: false,
        hasError: false,
      };
    case UPDATE_ITEM_CART_FAIL:
      const errorUpdateCart = getFormattedValidationErrorFromAction(action);
      return {
        ...state,
        finishRequests: true,
        cartFinishRequests: false,
        isLoading: false,
        isUpdating: false,
        error: errorUpdateCart,
        shipping: {
          isLoading: false,
          error: action && action.error && action.error.data,
          fetchShipping: false,
          error_get_shipping: true,
        },
        hasError: true,
        statusCode: action.status
      }

    case DELETE_ITEM_CART:
      return {
        ...state,
        isLoading: true,
        wasModified: true,
        isUpdating: true,
        finishRequests: false,
        cartFinishRequests: false,
      };
    case DELETE_ITEM_CART_SUCCESS:
      return {
        ...state,
        finishRequests: true,
        isLoading: false,
        isUpdating: false,
        cartFinishRequests: false,
      };
    case DELETE_ITEM_CART_FAIL:
      const errorDeleteCart = getFormattedValidationErrorFromAction(action) 

      return {
        ...state,
        finishRequests: true,
        cartFinishRequests: false,
        isLoading: false,
        isUpdating: false,
        error: errorDeleteCart,
        hasError: true,
        errorData: errorDeleteCart,
        statusCode: action.status,
      };

    case ADD_COUPON_TO_CART:
      return {
        ...state,
        isLoadingCoupon: true,
        finishRequests: false,
        cartFinishRequests: false,
        isSuccessCoupon: false,
        errorSkus: [],
      };
    case ADD_COUPON_TO_CART_SUCCESS:
      return {
        ...state,
        isLoadingCoupon: false,
        finishRequests: true,
        cartFinishRequests: false,
        coupon: action.payload.data,
        isSuccessCoupon: true,
      };
    case ADD_COUPON_TO_CART_FAIL:
      const errorAddCoupon = getFormattedValidationErrorFromAction(action);

      let { message, errorSkus } = errorAddCoupon;

      return {
        ...state,
        isLoadingCoupon: false,
        errorMessageCoupon: message,
        errorSkus,
        isError: true,
        finishRequests: true,
        cartFinishRequests: false,
        isSuccessCoupon: false,
      };
    case REMOVE_COUPON_TO_CART:
      return {
        ...state,
        isLoadingCoupon: true,
        finishRequests: false,
        cartFinishRequests: false,
      };
    case REMOVE_COUPON_TO_CART_SUCCESS:
      return {
        ...state,
        isLoadingCoupon: false,
        finishRequests: true,
        cartFinishRequests: false,
        coupon: null,
      };
    case REMOVE_COUPON_TO_CART_FAIL:
      const errorRemoveCoupon = getFormattedValidationErrorFromAction(action);
      const { message: messageRemoveCoupon } = errorRemoveCoupon;
      return {
        ...state,
        isLoadingCoupon: false,
        errorMessageCoupon: messageRemoveCoupon,
        isError: true,
        finishRequests: true,
        cartFinishRequests: false,
      };
    case RESET_ERROR_MESSAGE_COUPON:
      return {
        ...state,
        errorMessageCoupon: null,
        errorSkus: [],
        errorSkusCart: [],
      };
    default:
      return { ...state };
  }
};

export default CartReducer;
